import React, { useEffect, useRef, useState } from 'react';
import QRCodeStyling from 'qr-code-styling';
import './App.css';

function App() {
  const [text, setText] = useState('');
  const [color, setColor] = useState('#000000');
  const qrRef = useRef(null);
  const qrCode = useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {

    const rawQuery = window.location.search;
    const extractedText = rawQuery.startsWith('?') ? rawQuery.substring(1) : '';

    // Set text state if valid
    if (extractedText) {
      setText(decodeURIComponent(extractedText));
    }

    qrCode.current = new QRCodeStyling({
      width: 300,
      height: 300,
      type: 'canvas',
      data: '',
      image: '',
      dotsOptions: {
        color: color,
        type: 'dots',
      },
      backgroundOptions: {
        color: '#ffffff',
      },
      cornersSquareOptions: {
        type: 'extra-rounded',
      },
      cornersDotOptions: {
        type: 'dot',
      },
    });
  }, []);

  // Update on text/color change
  useEffect(() => {
    if (qrCode.current && qrRef.current) {
      qrRef.current.innerHTML = '';
      qrCode.current.update({
        data: text,
        dotsOptions: { color: color },
      });
      qrCode.current.append(qrRef.current);
    }
  }, [text, color]);

  const handleDownload = () => {
    const downloadQr = new QRCodeStyling({
      width: 1024,
      height: 1024,
      type: 'canvas',
      data: text,
      image: '',
      dotsOptions: {
        color: color,
        type: 'dots',
      },
      backgroundOptions: {
        color: '#ffffff',
      },
      cornersSquareOptions: {
        type: 'extra-rounded',
      },
      cornersDotOptions: {
        type: 'dot',
      },
    });

    downloadQr.download({ name: 'qr-code', extension: 'png' });
  };

  return (
    <div className="app-container">
      <div className="qr-card">
        <h1>QR Code Generator</h1>
        <input
          type="text"
          style={{ width: '92%' }}
          placeholder="Enter text or URL"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <input
          type="color"
          value={color}
          onChange={(e) => setColor(e.target.value)}
        />
        <button onClick={() => setText(text)}>Generate</button>

        {text && (
          <div className="qr-preview">
            <div ref={qrRef} />
            <p>{text}</p>
            <button onClick={handleDownload} style={{ marginTop: '1rem', backgroundColor: '#10b981' }}>
              Download QR Code
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;